export const APP = "APP_";

export const CONTROLLER = "CONTROLLER_";
export const ACCESS_CONTROL = "ACCESSCONTROL_";
export const APP_WIDGET = "APPWIDGET_";
export const AIR_CONDITIONER = "AIRCONDITIONER_";
export const CURTAIN = "CURTAIN_";
export const CAMERA = "CAMERA_";
export const DIMMER_LIGHT = "DIMMERLIGHT_";
export const ELEVATOR = "ELEVATOR_";
export const LIGHT = "LIGHT_";
export const LIGHT_METER = "LIGHTMETER_";
export const POWER_SWITCH = "POWERSWITCH_";
export const SWITCH_BINARY = "SWITCHBINARY_";
export const HIDDEN_SWITCH = "HIDDENSWITCH_";
export const WATERING_SWITCH = "WATERINGSWITCH_";
export const THERMOMETER = "THERMOMETER_";
export const HUMIDITY = "HUMIDITY_";
export const DOORBELL = "DOORBELL_";
export const DOORLOCK = "DOORLOCK_";
export const AREA = "AREA_";
export const BUILDING = "BUILDING_";
export const DEVICE = "DEVICE_";
export const USER = "USER_";
export const OUTLET = "OUTLET_";
export const SIREN = "SIREN_";
export const MOTION_SENSOR = "MOTIONSENSOR_";
export const NOTIFY = "NOTIFY_";
export const SCENARIO = "SCENARIO_";
export const RESERVATION = "RESERVATION_";
export const API = "API_";
export const SUBSCRIBE = "SUBSCRIBE_";
export const UNSUBSCRIBE = "UNSUBSCRIBE_";
export const USERMESSAGE = "USERMESSAGE_";
export const PLAY_LIST = "PLAY_LIST_";
export const SMART_SPEAKER = "SMARTSPEAKER_";
export const SMART_PARKING = "SMARTPARKING_";
export const LEAK_DETECTOR = "LEAKDETECTOR_";
export const SENSOR_BINARY = "SENSORBINARY_";
export const VOLTAGE = "VOLTAGE_";
export const TCPSENSOR = "TCPSENSOR_";
